// extracted by mini-css-extract-plugin
module.exports = {"Container":"style_Container__1Wu9y","Title":"style_Title__1Pq95","Body":"style_Body__2mF89","Button":"style_Button__1pey6"};